import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Toolbar } from "@mui/material";
import { useState } from "react";
import logo from "../../images/porterbrook-lockup-hero-rgb.svg";
import { Search } from "../SearchInput";
import Sidebar from '../Sidebar';
import { AppBar } from './AppBar';
import { BasketBadge } from './BasketBadge';
import { ReturnBadge } from "./ReturnBadge";
import './index.scss';
import { ProfileAvatarMenu } from './ProfileAvatarMenu';


export const Header = (...props: any) => {

    const [open, setOpen] = useState(false);
    const [pinned, setPinned] = useState(false);

    const handleDrawerOpen = (pin?: boolean) => {
        setOpen(true);
        if (pin)
            setPinned(true);
    };

    const handleDrawerClose = (unpin?: boolean) => {
        setOpen(false);
        if (unpin)
            setPinned(false);
    };

    return (
        <Box sx={{ flexGrow: 1, marginBottom: '100px' }}>
            <AppBar position="fixed" open={open}>
                <Toolbar className="app-toolbar">
                    <IconButton
                        size="large"
                        edge="start"
                        onClick={() => { handleDrawerOpen(true); }}
                        color="inherit"
                        aria-label="open drawer"
                        sx={{
                            marginRight: 2,
                            ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <a href="/" className="brand-link" aria-label="Porterbrook SIMS home">
                        <img src={logo} className="logo" alt="Porterbrook" />
                    </a>
                    <Search />
                    <Box sx={{ flexGrow: 1 }} />
                    <ReturnBadge />
                    <BasketBadge />
                    <ProfileAvatarMenu />
                </Toolbar>
            </AppBar>
            <Sidebar
                open={open}
                pinned={pinned}
                handleClose={handleDrawerClose}
                handleOpen={handleDrawerOpen}
            />
        </Box>
    );

}

